import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import * as Styled from './LoadingView.styled';

/**
 * A loading animation that expands to the width and height of its container
 */
const Loading = ({ className }) => (
  <Styled.Loader className={className}>
    <Styled.Glyph>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-1.svg"
        alt=""
      />
    </Styled.Glyph>
    <Styled.Glyph delay={700}>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-2.svg"
        alt=""
      />
    </Styled.Glyph>
    <Styled.Glyph delay={1400}>
      <img
        src="https://assets.bombas.com/image/upload/v1642172311/frontend/loading-icon-3.svg"
        alt=""
      />
    </Styled.Glyph>
  </Styled.Loader>
);

const LoadingView = () => (
  <Styled.LoadingView>
    <Loading />
  </Styled.LoadingView>
);

/**
 * Appends a full page loader to the DOM
 */
const LoadingViewContainer = () => {
  const containerRef = useRef(document.createElement('div'));

  useEffect(() => {
    const element = containerRef.current;

    document.body.appendChild(element);
    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return createPortal(<LoadingView />, containerRef.current);
};

Loading.propTypes = {
  className: PropTypes.string
};

Loading.defaultProps = {
  className: ''
};

export { Loading, LoadingView };
export default LoadingViewContainer;
